import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import Api from '@/services';
const initState = {
    showSwiper: false,
    swiperProps: {
        type: 0,
    },
    // 搜索信息
    searchInfo: {
        bannerName: '',
        publishTimeArr: [],
    },
    items: [],
    // 总条数
    totalNumber: 0,
    // 当前第几页
    currentIndex: 1,
    // 分页尺寸
    pageSize: 20,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         *  加载列表
         */
        updateTable(currentIndex, { update, state, rootState }) {
            const params = {
                bannerName: state.searchInfo.bannerName,
                startTime: state.searchInfo.publishTimeArr ? state.searchInfo.publishTimeArr[0] : '',
                endTime: state.searchInfo.publishTimeArr ? state.searchInfo.publishTimeArr[1] : '',
                pageIndex: currentIndex || 1,
                pageSize: state.pageSize,
            };
            Api.system.operatingData(params).then((data) => {
                this.SET_STATE(Object.assign({}, data));
            });
        },
        /**
         * 上架/下架
         */
        changeShelves(payload, { update, state, rootState }) {
            const params = { id: payload.id };
            const url = payload.status === '已上架' ? 'offShelves' : 'onShelves';
            Api.system.changeShelves(params, url).then((res) => {
                if (res.operateStatus) {
                    notification.success({
                        message: res.msg,
                        description: res.reason,
                    });
                    this.updateTable(1);
                }
                else {
                    notification.error({
                        message: res.msg,
                        description: res.reason,
                    });
                }
            });
        },
        /**
         *  搜索列表
         */
        onSearch(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.CHANGE_SEARCH_INFO(payload);
            });
        },
        /**
         *  列表操作 编辑
         */
        edit(payload) {
            this.SHOW_SWIPPER({ type: 1, id: payload.id });
        },
        /**
         *  列表操作 查看
         */
        look(payload) {
            this.SHOW_SWIPPER({ type: 2, id: payload.id });
        },
        /**
         * 新建轮播图
         */
        newSwiper(payload) {
            this.SHOW_SWIPPER(payload);
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        // 搜索信息
        CHANGE_SEARCH_INFO(state, payload) {
            state.searchInfo = Object.assign({}, payload);
        },
        HIDE_SWIPPER(state, payload) {
            state.showSwiper = false;
        },
        SHOW_SWIPPER(state, payload) {
            state.showSwiper = true;
            state.swiperProps = Object.assign({}, payload);
        },
    },
});
/**
 * @argument 考虑接口以及接口的数据处理
 */
